<template>
  <div>
    <div>
      <div class="section section-blue">
        <!-- BEGIN container -->
        <div class="container">
          <!-- BEGIN row -->
          <div class="row ">
            <div
              class="col-md-12 justify-content-center mb-3"
              style="display: flex;"
            >
              <h3 class="text-white">
                Unleash The Power Of Your Medical Data With Womia <br />
                <div
                  class="sparator mt-4"
                  style=" border-bottom: 1px solid rgba(255, 255, 255, 0.2); margin: 0 -80px;"
                ></div>
              </h3>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-12 justify-content-center"
              style="display: flex; font-size: 20px;"
            >
              <div class="social subscription">
                <div class="social-list">
                  <a href="/beta/contact-us"><i class="fa fa-envelope" style="font-size: smaller;"></i></a>
                  <a href="https://www.facebook.com/profile.php?id=100092753127914"><i class="fa fa-facebook"></i></a>
                  <a href="https://www.linkedin.com/company/womia-io/"><i class="fa fa-linkedin"></i></a>
                  <a href="https://www.youtube.com/@womia4930"><i class="fa fa-youtube-play"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN #footer -->
    <div class="footer">
      <div class="container">
        <div class="row gx-lg-5">
          <div class="col-lg-5 mb-4 mb-lg-0">
            <div class="footer-logo">
              <span class="footer-logo-text"
                >Womia Box<small style="width: 50px;">by WOMIA</small></span
              >
            </div>
            <p class="footer-desc">
              Womia Box helps clinician create and distribute <br>their own annotated medical Data catlogs for AI work <br> while preserving data ownership and patient privacy.
            </p>
            <h4 class="footer-title">Subscribe</h4>
            <div id="subscribe">
              <div class="input-group position-relative mb-2 w-50">
                <input type="text" class="form-control rounded-pill-start border-0 fw-normal px-3" v-model="email" placeholder="Enter email address" style="background-color:rgb(233 235 236);">
                <button type="button" class="btn text-dark icon-bell " style="background-color:rgb(233 235 236);  " @click="subscribe()">
                <i class="fa fa-send"></i>
                </button>
              </div>
                <small :class="message.alert" class="alert text-center m-0 justify-content-center d-flex" v-if="message.text" role="alert" style="width: 50%;">
                  <span class="close" @click="message = {}">×</span>
                  {{ message.text }}
                </small>
            </div>

          </div>
          <div class="col-lg-2 mb-4 mb-lg-0">
            <h4 class="footer-title">Catalogs</h4>
            <ul class="footer-link-list">
              <li>
                <a href="/index.html#ct">CT</a>
              </li>
              <li><a href="/index.html#mri">MRI</a></li>
              <li><a href="/index.html#xray">Xray</a></li>
              <li><a href="/index.html#dental">Dental</a></li>
              <li><a href="/index.html#eeg">EEG</a></li>
              <li><a href="/index.html#ecg">ECG</a></li>
            </ul>
            <hr class="my-4 text-gray-600" />
            <h4 class="footer-title">
              Company
            </h4>
            <ul class="footer-link-list">
              <li><a href="https://www.womia.io/">Womia</a></li>
            </ul>
          </div>
          <div class="col-lg-2 mb-4 mb-lg-0">
            <h4 class="footer-title">Related Links</h4>
            <ul class="footer-link-list">
              <li><a href="/index.html">About Womia Box</a></li>
              <li><a href="/beta/sign-up">Create Account</a></li>
              <li><a href="/beta/auth">Login</a></li>
            </ul>
          </div>
          <div class="col-lg-2 mb-4 mb-lg-0">
            <h4 class="footer-title">Contact</h4>
            <ul class="footer-link-list">
              <li><a href="mailto:hello@womia.io">Email: hello@womia.io</a></li>
              <li><a href="/beta/contact-us">Contact Us</a></li>
            </ul>
          </div>
        </div>
        <div class="footer-copyright">
          <div class="row">
            <div class="col-lg-6 text-center text-lg-start mb-3 mb-lg-0">
              <div class="footer-copyright-text">
                © 2024 womia.io. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterBrand",
  data() {
    return {
      email: null,
      message: {}
    };
  },
  methods: {
    showMessage(message) {
      this.message = message;
    },
    subscribe() {
      this.message = {};
      this.$http.post(`subscription/subscribe`, { email: this.email }).then(
        response => {
          this.showMessage({
            text: "Thank you for subscribing!",
            alert: "alert-success"
          });
          this.email = null;
        },
        err => {
          // error callback
          if (
            err.body &&
            err.body.message === "subscription.email.alreadysubscribed"
          ) {
            this.showMessage({
              text: "Sorry, this email is already subscribed",
              alert: "alert-danger"
            });
          } else {
            this.showMessage({
              text: "Sorry, your email is not valid",
              alert: "alert-danger"
            });
          }
        }
      );
    }
  }
};
</script>
<style>
.section-blue {
  background: linear-gradient(to bottom, #E21919, #E95913);
}
</style>
<style scoped>
.social .social-list {
  text-align: center;
}

.social .social-list a {
  color: #ffffffba;
  font-size: 24px;
  padding-left: 25px;
}
.social .social-list a:first-child{
  padding-left: 0px;
}

.social .social-list a:hover {
  color: #474747;
}

.fa-send{
  color: rgba(var(--bs-component-color-rgb),.5)
}
.icon-bell:hover>.fa-send {
  color:#2D353c;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBrand.vue